// extracted by mini-css-extract-plugin
export default {"paymentSection":"s1-z","disabled":"t1-z"};